import React from "react";
import StatsCard from "./StatCard";

export default function StatsMarquee({ stats }) {
  if (!stats?.length) return null;

  const doubled = [...stats, ...stats];

  return (
    <div className="w-full overflow-hidden border-b bg-white">
      <div className="marquee-track gap-3 py-2 px-3">
        {doubled.map((item, i) => (
          <StatsCard
            key={i}
            title={item.title}
            value={item.value}
            color={item.color}
            icon={React.cloneElement(item.icon, { size: 14 })}
          />
        ))}
      </div>
    </div>
  );
}
